import { SessionTimeoutConfig } from '@shared/session'
import { IntlShape } from 'react-intl'

export const getTranslations = (
  formatMessage: IntlShape['formatMessage'],
  sessionTimeoutConfig: SessionTimeoutConfig,
) =>
  ({
    heading: `${formatMessage({ id: 'common-logout' })}?`,
    leadText: formatMessage(
      { id: 'common-logout-modal-lead-text' },
      { numOfMinutes: sessionTimeoutConfig.sessionLimitInMinutes },
    ),
    timerLabel: formatMessage({ id: 'common-logout-modal-session-end-time-label' }),
    primaryButtonLabel: formatMessage({ id: 'common-logout' }),
    secondaryButtonLabel: formatMessage({ id: 'common-cancel' }),
  }) as const
